import React from 'react';
import InsightIndexSection from './InsightIndexSection';
import { InsightIndexEntry } from '../../types';

interface PsychologicalDriversChartProps {
  data: Array<InsightIndexEntry | Record<string, any>>;
  primaryColor?: string;
  secondaryColor?: string;
}

export default function PsychologicalDriversChart({
  data,
  primaryColor = '#0EA5E9',
  secondaryColor = '#14B8A6',
}: PsychologicalDriversChartProps) {
  return (
    <InsightIndexSection
      title="Psychological Drivers"
      insights={data}
      primaryColor={primaryColor}
      accentColor={secondaryColor}
      icon="🧠"
      subtitle="BASELINE: Online Adult Population | CONTAINS: Engaged Audiences Data"
      emptyMessage="Upload a Psychological Drivers insight file in the admin panel to populate this section."
    />
  );
}
